import { useEffect } from 'react';

import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { token as tokenStorage } from 'services/LocalStorage/localStorage';
import { Userpilot } from 'userpilot';

import { useMobileStore } from 'store/mobile.store';
import { useUserStore } from 'store/user.store';

export const Logout = () => {
    const queryClient = useQueryClient();
    const history = useHistory();
    const logout = useUserStore((state) => state.logout);
    const updateMobile = useMobileStore((state) => state.update);

    useEffect(() => {
        tokenStorage.clear();
        queryClient.clear();
        updateMobile({ isMobile: false });
        logout();
        try {
            Userpilot.clean();
            Userpilot.destroy();
        } catch (e) {
            console.log(e);
            console.log('error userpilot');
        }
        history.push('/');
        window.location.reload();
    }, []);

    return null;
};
